import React from 'react';
import PropTypes from 'prop-types';
import { useIntl } from '@godaddy/react-mintl';
import Link from '@ux/link';

const SignIn = ({ loginLink, appEid, isReseller }) => {
  const { formatMessage } = useIntl();

  const pageEid = appEid.extend('sign_in');
  const signInLinkEid = pageEid('signin_link.link.click') || '';

  const messages = {
    signInLinkText:
      formatMessage({ id: 'Shared:AccountTray:SignIn' }),
    registeredUsers:
      formatMessage({ id: 'Shared:AccountTray:RegisteredUser' }),
    signInAccountMessage:
      formatMessage({ id: 'Shared:AccountTray:SignInAccountMessage' })
  };

  return (
    <div className='sign-in-section account-info-section'>
      { !isReseller &&
        <>
          <div className='account-info-title'>
            <span>{ messages.registeredUsers }</span>
          </div>
          <div className='account-info-text'>
            <span>{ messages.signInAccountMessage }</span>
          </div>
        </>
      }
      <Link
        href={ loginLink }
        data-eid={ signInLinkEid }
        className='account-info-section-link'
        aria-label={ messages.signInLinkText }>
        <span>{ messages.signInLinkText }</span>
      </Link>
    </div>
  );
};

SignIn.propTypes = {
  loginLink: PropTypes.string.isRequired,
  appEid: PropTypes.func,
  isReseller: PropTypes.bool
};

export default SignIn;
